import React, {Component} from 'react';
import InvalidLinkComponent from '../InvalidLinkComponent/InvalidLinkComponent';
import ResendLinkComponent from '../ResendLinkComponent/ResendLinkComponent';
import PropTypes from 'prop-types';

class InvalidLinkPageComponent extends Component {
    static get propTypes() {
        return {
            actionLocation: PropTypes.string,
            lingua: PropTypes.shape({read: PropTypes.func, exists: PropTypes.func}),
            isWaiting: PropTypes.bool,
            enableLoading: PropTypes.func,
            disableLoading: PropTypes.func,
            updatePage: PropTypes.func
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            resendLink: false
        };
    }

    handleActivateResendLink = () => {
        this.setState({resendLink: true});
    };

    render() {
        if (this.state.resendLink) {
            return (
                <ResendLinkComponent
                    actionLocation={this.props.actionLocation}
                    lingua={this.props.lingua}
                    isWaiting={this.props.isWaiting}
                    enableLoading={this.props.enableLoading}
                    disableLoading={this.props.disableLoading}
                    updatePage={this.props.updatePage}
                />
            );
        }
        return (
            <InvalidLinkComponent
                lingua={this.props.lingua}
                handleResendLink={this.handleActivateResendLink}
            />
        );
    }
}

export default InvalidLinkPageComponent;
